import script from "./QueryColChip.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryColChip.vue?vue&type=script&setup=true&lang=js"

import "./QueryColChip.vue?vue&type=style&index=0&id=c709d702&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c709d702"]])

export default __exports__